// nulllabs override of livekit-examples/meet@665e1cb7 lib/client-utils.ts
// consumers: app/page.tsx, app/rooms/[roomName]/PageClientImpl.tsx,
//            app/api/connection-details/route.ts (randomString)
// deps: Web Crypto (global `crypto` — present in browsers and Node >=18)
//
// Change vs upstream: randomString() used Math.random(), which is NOT a CSPRNG.
// Harmless for a room id or a participant suffix, but this same function
// generates the E2EE PASSPHRASE — i.e. the media encryption key. Math.random()
// is seeded from and recoverable through observable output in several engines,
// so a 64-char key built from it carries nowhere near 64 chars of entropy.
// Swapped for crypto.getRandomValues with rejection sampling (a plain modulo
// over 256 would bias the first 4 symbols of a 36-symbol alphabet).
export function encodePassphrase(passphrase: string) {
  return encodeURIComponent(passphrase);
}

export function decodePassphrase(base64String: string) {
  return decodeURIComponent(base64String);
}

export function generateRoomId(): string {
  return `${randomString(4)}-${randomString(4)}`;
}

export function randomString(length: number): string {
  const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
  const n = characters.length; // 36
  // Largest multiple of n that fits in a byte; values at/above are rejected so
  // every symbol is equiprobable.
  const limit = Math.floor(256 / n) * n; // 252
  let result = '';
  const buf = new Uint8Array(length * 2);
  while (result.length < length) {
    crypto.getRandomValues(buf);
    for (let i = 0; i < buf.length && result.length < length; i++) {
      if (buf[i] < limit) result += characters.charAt(buf[i] % n);
    }
  }
  return result;
}

export function isLowPowerDevice() {
  return navigator.hardwareConcurrency < 6;
}

export function isMeetStaging() {
  return new URL(location.origin).host === 'meet.staging.livekit.io';
}
